function initElsyProduct(root) {
  if (root.dataset.ready) return;
  const variants = JSON.parse(root.querySelector('[data-variants]').dataset.variants);
  root.dataset.ready = 'true';
  const slides = [...root.querySelectorAll('.er-slide')];
  const thumbs = [...root.querySelectorAll('[data-thumbnail]')];
  let index = Math.max(0, slides.findIndex(slide => !slide.hidden));
  const show = next => {
    if (!slides.length) return;
    index = (next + slides.length) % slides.length;
    slides.forEach((slide, i) => { slide.hidden = i !== index; });
    thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
    const counter = root.querySelector('[data-counter]');
    if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
  };
  root.querySelectorAll('[data-js-control]').forEach(el => { el.hidden = false; });
  root.querySelector('[data-option-controls]')?.removeAttribute('hidden');
  if (root.querySelector('[data-option-controls]')) root.querySelector('[data-native-variant]').hidden = true;
  root.querySelector('[data-prev]')?.addEventListener('click', () => show(index - 1));
  root.querySelector('[data-next]')?.addEventListener('click', () => show(index + 1));
  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
  const stage = root.querySelector('.er-stage');
  stage.addEventListener('keydown', e => {
    if (e.target !== stage || !['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
    e.preventDefault(); show(index + (e.key === 'ArrowRight' ? 1 : -1));
  });
  let start;
  stage.addEventListener('pointerdown', e => {
    if (e.target.closest('button') || e.button !== 0) return;
    start = { x: e.clientX, y: e.clientY, id: e.pointerId };
    stage.setPointerCapture(e.pointerId);
  });
  stage.addEventListener('pointerup', e => {
    if (!start || start.id !== e.pointerId) return;
    const dx = e.clientX - start.x, dy = e.clientY - start.y;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
    start = null;
  });
  stage.addEventListener('pointercancel', () => { start = null; });
  const select = root.querySelector('[data-variant-select]');
  const fields = [...root.querySelectorAll('[data-option-index]')];
  const quantity = root.querySelector('[name="quantity"]');
  const add = root.querySelector('[name="add"]');
  const update = variant => {
    const available = Boolean(variant?.available);
    select.disabled = !variant;
    if (variant) {
      select.value = String(variant.id);
      root.querySelector('[data-product-price]').textContent = variant.price;
      const compare = root.querySelector('[data-compare-price]');
      compare.textContent = variant.compare || ''; compare.hidden = !variant.compare;
      quantity.min = variant.min; quantity.step = variant.step;
      if (variant.max != null) quantity.max = variant.max; else quantity.removeAttribute('max');
      let qty = Math.max(variant.min, Number(quantity.value) || variant.min);
      qty = variant.min + Math.floor((qty - variant.min) / variant.step) * variant.step;
      if (variant.max != null) qty = Math.min(qty, variant.max);
      quantity.value = qty;
      const imageIndex = slides.findIndex(slide => slide.dataset.imageId === String(variant.image));
      if (imageIndex >= 0) show(imageIndex);
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
    }
    add.disabled = !available;
    add.textContent = available ? root.dataset.addLabel : variant ? root.dataset.soldLabel : root.dataset.unavailableLabel;
    root.querySelector('[data-payment]').hidden = !available;
  };
  fields.forEach(field => field.addEventListener('change', () => {
    const values = fields.map(f => f.querySelector('input:checked')?.value);
    fields.forEach((f, i) => { f.querySelector('[data-option-value]').textContent = f.querySelector('input:checked')?.closest('label').querySelector('span').textContent || ''; });
    update(variants.find(v => v.options.every((value, i) => value === values[i])));
  }));
  select.addEventListener('change', () => update(variants.find(v => String(v.id) === select.value)));
  root.querySelector('[data-quantity-minus]').addEventListener('click', () => { quantity.stepDown(); quantity.dispatchEvent(new Event('change', { bubbles: true })); });
  root.querySelector('[data-quantity-plus]').addEventListener('click', () => { quantity.stepUp(); quantity.dispatchEvent(new Event('change', { bubbles: true })); });
  show(index);
}
function initElsyProducts(container = document) { container.querySelectorAll('[data-product-section]').forEach(initElsyProduct); }
initElsyProducts();
document.addEventListener('shopify:section:load', e => initElsyProducts(e.target));
function fitElsyGalleries() {
  const header = document.querySelector('.header');
  const stickyTop = Math.max(12, (header?.getBoundingClientRect().bottom || 0) + 12);
  const viewportHeight = window.visualViewport?.height || window.innerHeight;
  document.querySelectorAll('.er-gallery').forEach(gallery => {
    const top = Math.max(stickyTop, gallery.getBoundingClientRect().top);
    const thumbnails = gallery.querySelector('.er-thumbnails');
    const reserve = thumbnails && !thumbnails.hidden ? thumbnails.getBoundingClientRect().height : 0;
    gallery.style.setProperty('--er-sticky-top', `${stickyTop}px`);
    gallery.style.setProperty('--er-stage-height', `${Math.max(120, viewportHeight - top - reserve - 16)}px`);
  });
}
let elsyGalleryFrame;
function queueElsyGalleryFit() {
  if (elsyGalleryFrame) return;
  elsyGalleryFrame = requestAnimationFrame(() => { elsyGalleryFrame = null; fitElsyGalleries(); });
}
window.addEventListener('resize', queueElsyGalleryFit, { passive: true });
window.addEventListener('scroll', queueElsyGalleryFit, { passive: true });
window.visualViewport?.addEventListener('resize', queueElsyGalleryFit, { passive: true });
document.addEventListener('shopify:section:load', queueElsyGalleryFit);
if (document.querySelector('.header') && 'ResizeObserver' in window) new ResizeObserver(queueElsyGalleryFit).observe(document.querySelector('.header'));
fitElsyGalleries();
document.querySelectorAll('[data-cart-page]').forEach(page => {
  let pending = false;
  async function changeLine(row, quantity) {
    if (pending) return;
    pending = true;
    const form = page.querySelector('[data-cart-form]');
    const error = page.querySelector('.er-cart-error');
    error.hidden = true; form.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(page.dataset.changeUrl, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:row.dataset.key, quantity})});
      if (!response.ok) throw new Error('Cart update failed');
      await response.json(); window.location.reload();
    } catch (_) { error.textContent = page.dataset.error; error.hidden = false; form.removeAttribute('aria-busy'); pending = false; }
  }
  page.addEventListener('click', event => { const remove = event.target.closest('[data-remove-item]'); if (!remove) return; event.preventDefault(); changeLine(remove.closest('[data-cart-row]'), 0); });
  page.addEventListener('change', event => { if (!event.target.matches('input[name="updates[]"]')) return; const value=Number(event.target.value); if(Number.isInteger(value)&&value>=0) changeLine(event.target.closest('[data-cart-row]'),value); });
});
if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {if(entry.isIntersecting){entry.target.classList.add('er-reveal');observer.unobserve(entry.target);}}),{threshold:.06});
  document.querySelectorAll('.shop-card,.editorial-copy,.search-form,.shop-toolbar').forEach((el,i)=>{el.style.setProperty('--er-delay',`${Math.min(i%5,4)*45}ms`);observer.observe(el);});
}
